/**
 * @generated SignedSource<<1ee2efd86270ed04f2e1d144eef7fd3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ChannelSelectorQuery$variables = {
  memberOnly?: boolean | null;
  query?: string | null;
};
export type ChannelSelectorQuery$data = {
  readonly channels: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type ChannelSelectorQuery = {
  response: ChannelSelectorQuery$data;
  variables: ChannelSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberOnly"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "excludePersonal",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "memberOnly",
        "variableName": "memberOnly"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "query"
      }
    ],
    "concreteType": "Channel",
    "kind": "LinkedField",
    "name": "channels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChannelSelectorQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChannelSelectorQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "371fff98f7394ce452eff79dbf94b6f4",
    "id": null,
    "metadata": {},
    "name": "ChannelSelectorQuery",
    "operationKind": "query",
    "text": "query ChannelSelectorQuery(\n  $query: String\n  $memberOnly: Boolean\n) {\n  channels(excludePersonal: true, search: $query, memberOnly: $memberOnly) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f248baea04a3830b1c04435daa19973";

export default node;
